import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Beforeunload } from "react-beforeunload";
import logo from "../Assets/bg.jpg";

import {
  Badge,
  Calendar,
  Layout,
  Menu,
  Drawer,
  List,
  Input,
  Button,
  Select,
  Spin,
  Modal,
  Image,
} from "antd";
import {
  SearchOutlined,
  CalendarOutlined,
  MenuOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  PieChartOutlined,
  DashboardOutlined,
  PicLeftOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const { Header, Sider, Content, Footer } = Layout;

const contentStyle = {
  padding: 50,
  background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
};
const content = <div style={contentStyle} />;

function JobBoard() {
  const navigate = useNavigate();
  const handleMenuClick = (e) => {
    navigate(e.key); // e.key will be route path
  };
  const authIDToken = localStorage.getItem("idToken");
  process.env.NODE_ENV === "development"
    ? (document.title = "HS DEV MODE | Job Board")
    : (document.title = "Job Board | Hansoftware");

  const [searchTerm, setSearchTerm] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [calendarViewDate, setCalendarViewDate] = useState(dayjs());
  const [selectedMenuKey, setSelectedMenuKey] = useState("1");

  const [jobData, setJobData] = useState([]);
  const [jobDataLoading, setJobDataLoading] = useState(true);

  const [showImage, setShowImage] = useState(false);

  // MODAL
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // GET AWS DATA (DYNAMO FROM LAMBDA)
  useEffect(() => {
    getJobTickets();
  }, []);

  const getJobTickets = async () => {
    setJobDataLoading(true);
    await axios
      .get("https://api.hansoftware.net/getJobTickets", {
        headers: {
          Authorization: `Bearer ${authIDToken}`, // from your Cognito login response
        },
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          //setJobData(response.data.itemArray);
          setJobDataLoading(false);
          // process data for calendar
          processJobData(response.data.itemArray);
          //console.log(response.data.itemArray);
        } else {
          // error
          setJobDataLoading(false);
          console.log("Error:" + response.data.err);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const processJobData = (jobInfo) => {
    var dataArr = [];
    for (let row in jobInfo) {
      let img = jobInfo[row].imageKey;
      let desc = jobInfo[row].calendarDesc;
      let status = jobInfo[row].calendarStatus;
      if (status === "complete") {
        status = "success";
      } else if (status === "in progress") {
        status = "warning";
      } else if (status === "incomplete") {
        status = "error";
      } else {
        // no status
        status = "default";
      }
      let ticketData = jobInfo[row].ticketData;
      let obj = {
        date: ticketData.callDate,
        title: `${ticketData.eta} - ${ticketData.custName}`,
        status: status,
        description: desc,
        image: img,
        ticket: ticketData,
      };
      dataArr.push(obj);
      console.log(obj);
    }
    setJobData(dataArr);
  };

  // CALENDAR FUNCTIONS
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const onSelectDate = (value, info) => {
    if (info?.source === "date") {
      setSelectedDate(value);
      setDrawerVisible(true);
    }
  };
  const handleEventClick = (dateStr) => {
    const day = dayjs(dateStr);
    setSelectedDate(day);
    setCalendarViewDate(day);
    setDrawerVisible(true);
  };
  const handleReset = () => {
    const today = dayjs();
    setCalendarViewDate(today);
    setSelectedDate(today);
    setDrawerVisible(false);
  };
  const onPanelChange = (value) => {
    setCalendarViewDate(value);
  };
  const getJobsByDate = (date) => {
    const dateStr = date.format("M/D/YY"); // DATE FORMAT
    return jobData.filter((job) => job.date === dateStr);
  };
  const dateCellRender = (value) => {
    const listData = getJobsByDate(value).filter(
      (job) =>
        job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {listData.map((item, index) => (
          <li key={index}>
            <Badge
              status={item.status}
              text={item.title}
              style={{ paddingLeft: 4 }}
            />
          </li>
        ))}
      </ul>
    );
  };
  const selectedDateJobs = getJobsByDate(selectedDate);

  const menuItems = {
    1: "Calendar View",
    2: "Search Tickets",
    3: "Ticket View",
  };

  const CalendarContent = ({
    onSelectDate,
    searchTerm,
    setSearchTerm,
    filteredDates,
    handleEventClick,
  }) => (
    <div style={{ padding: 24, background: "#fff" }}>
      <Input.Search
        placeholder="Search jobs"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 16 }}
        allowClear
        autoFocus
      />
      {searchTerm && filteredDates.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3>Matching Jobs</h3>
          <List
            itemLayout="horizontal"
            dataSource={filteredDates.flatMap((date) =>
              getJobsByDate(dayjs(date))
                .filter(
                  (job) =>
                    job.title
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    job.description
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                )
                .map((job) => ({ ...job, date }))
            )}
            renderItem={(item) => (
              <List.Item
                onClick={() => handleEventClick(item.date)}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  title={item.title}
                  description={item.description}
                />
              </List.Item>
            )}
          />
        </div>
      )}
      {jobDataLoading ? (
        <Spin tip="Loading..." size="large">
          {content}
        </Spin>
      ) : (
        <Calendar
          value={calendarViewDate}
          cellRender={(value) => dateCellRender(value)}
          onSelect={onSelectDate}
          onPanelChange={onPanelChange}
          fullscreen
          headerRender={({ value, onChange }) => {
            const current = dayjs();
            const year = value.year();
            const month = value.month();

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0 8px",
                }}
              >
                <div style={{ display: "flex", gap: 8 }}>
                  <Select
                    value={year}
                    onChange={(newYear) => {
                      const newDate = value.clone().year(newYear);
                      onChange(newDate);
                      setCalendarViewDate(newDate);
                    }}
                  >
                    {Array.from({ length: 20 }, (_, i) => {
                      const y = current.year() - 10 + i;
                      return (
                        <Select.Option key={y} value={y}>
                          {y}
                        </Select.Option>
                      );
                    })}
                  </Select>

                  <Select
                    value={month}
                    style={{ width: 100 }}
                    onChange={(newMonth) => {
                      const newDate = value.clone().month(newMonth);
                      onChange(newDate);
                      setCalendarViewDate(newDate);
                    }}
                  >
                    {Array.from({ length: 12 }, (_, i) => (
                      <Select.Option key={i} value={i}>
                        {dayjs().month(i).format("MMMM")}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <Button
                  onClick={() => {
                    const today = dayjs();
                    onChange(today);
                    setCalendarViewDate(today);
                    setSelectedDate(today);
                    setDrawerVisible(false);
                    setSearchTerm("");
                  }}
                >
                  Reset to Today
                </Button>
              </div>
            );
          }}
        />
      )}
    </div>
  );

  const SearchContent = () => (
    <div style={{ padding: 24, background: "#fff" }}>
      <h3>Search Job Tickets</h3>
      <p>Search for specific job tickets based on customer name and/or date.</p>
    </div>
  );

  const filteredDates = Array.from(
    new Set(
      jobData
        .filter(
          (event) =>
            event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            event.description.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((event) => event.date)
    )
  );

  useEffect(() => {
    if (filteredDates.length > 0 && searchTerm) {
      const newDate = dayjs(filteredDates[0]);
      if (!calendarViewDate.isSame(newDate, "day")) {
        setCalendarViewDate(newDate);
      }
    }
  }, [searchTerm, filteredDates, calendarViewDate]);

  const renderContent = () => {
    switch (selectedMenuKey) {
      case "1":
        return (
          <CalendarContent
            onSelectDate={onSelectDate}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            filteredDates={filteredDates}
            handleEventClick={handleEventClick}
          />
        );
      case "2":
        return <SearchContent />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 32,
            margin: 16,
            color: "white",
            fontSize: 18,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {collapsed ? <MenuOutlined /> : "Menu"}
        </div>

        <Menu
          theme="dark"
          mode="inline"
          onClick={handleMenuClick}
          defaultSelectedKeys={["/dashboard/job-board"]}
          items={[
            {
              key: "/dashboard",
              icon: <PieChartOutlined />,
              label: "Dashboard",
            },
            {
              key: "/dashboard/job-board",
              icon: <DashboardOutlined />,
              label: "Job Board",
            },
            {
              key: "/dashboard/ticket-generator",
              icon: <PicLeftOutlined />,
              label: "Ticket Generator",
            },
            {
              key: "/dashboard/customer-list",
              icon: <UnorderedListOutlined />,
              label: "Customer List",
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ background: "#fff", padding: 0 }}>
          <div style={{ paddingLeft: 16, fontSize: 18 }}>
            {collapsed ? (
              <DoubleRightOutlined onClick={toggleCollapsed} />
            ) : (
              <DoubleLeftOutlined onClick={toggleCollapsed} />
            )}
            <span style={{ marginLeft: 16 }}>{menuItems[selectedMenuKey]}</span>
          </div>
        </Header>
        <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
          {renderContent()}
        </Content>
        <Footer style={{ textAlign: "center" }}>© 2025 Hansoftware</Footer>

        <Drawer
          title={`Jobs on ${selectedDate.format("MMMM D, YYYY")}`}
          placement="right"
          width={400}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
        >
          <List
            itemLayout="vertical"
            dataSource={selectedDateJobs}
            renderItem={(item) => (
              <List.Item>
                <Badge status={item.status} text={item.title} />
                <div style={{ marginTop: 8 }}>{item.description}</div>
                <Button
                  type="primary"
                  onClick={showModal}
                  style={{ marginTop: 8 }}
                >
                  See more
                </Button>
                <Modal
                  title={`${item.ticket.custName}, ${item.ticket.jobDate}`}
                  closable={{ "aria-label": "Custom Close Button" }}
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                >
                  <Button
                    onClick={() =>
                      window.open(
                        `https://www.hansoftware.net/${item.image}`,
                        "_blank"
                      )
                    }
                  >
                    Print Job Ticket
                  </Button>
                  <img
                    src={`https://www.hansoftware.net/${item.image}`}
                    crossOrigin="use-credentials"
                    width="auto" // make size fit modal width
                  />
                  <p>Address: {item.ticket.address}</p>
                  <p>
                    {item.ticket.unit.length > 0
                      ? `Unit: ${item.ticket.unit}`
                      : ""}
                  </p>
                  <p>ZIP: {item.ticket.zip}</p>
                  <p>
                    {item.ticket.community.length > 0
                      ? `Community: ${item.ticket.community}`
                      : ""}
                  </p>
                  <p>Gate Code: {item.ticket.gate}</p>
                  <p>Call Date: {item.ticket.callDate}</p>
                  <p>Plumber: {item.ticket.plumber}</p>
                  <p>ETA: {item.ticket.eta}</p>
                  <p>Job Notes: {item.ticket.notes}</p>
                  <p>Phone: {item.ticket.phone}</p>
                  <p>Email: {item.ticket.email}</p>
                  <p>Payment: {item.ticket.payment}</p>
                </Modal>
              </List.Item>
            )}
          />
        </Drawer>
      </Layout>
    </Layout>
  );
}

export default JobBoard;
